// removed by extract-text-webpack-plugin
module.exports = {"copyright":"footer-1vY","icon-list":"footer-EmB","made-in-ny":"footer-3dw"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/Footer/Copyright/copyright.module.scss
// module id = 296
// module chunks = 0